/**
 * @Author: Nemo
 * @Description: 动态表单测试页面
 * @Date: 2024-11-30
 * @FilePath: /rhcn-checkout-web/src/views/test/checkout/index.vue
 */
<template>
  <div class="checkout-container">
    <h1>动态表单测试页面</h1>

    <div class="form-wrapper" v-loading="loading">
      <dynamic-form
        v-if="!loading && formFields.length"
        ref="dynamicFormRef"
        :config="getPaymentConfig"
        :validation-mode="'format-only'"
        :show-submit-button="false"
      />
      <div v-else-if="!loading && !formFields.length" class="no-fields">
        没有可显示的表单字段
      </div>
    </div>

    <OnButton @click="handleSubmit">提交</OnButton>

    <div v-if="result" class="result-box">
      <h3>提交结果：</h3>
      <pre>{{ JSON.stringify(result, null, 2) }}</pre>
    </div>
  </div>
</template>

<script>
import { DynamicForm } from '@/componentsV2/busi/dynamic-form';
import { getFieldConfig } from '@/componentsV2/busi/dynamic-form/filed-manager';

import { fetchFormFields, submitFormData } from './mock-api';

export default {
  name: 'CheckoutTest',
  components: { DynamicForm },

  data() {
    return {
      formFields: [],
      loading: false,
      result: null,
      fieldType: 'payment', // 设置为支付信息
      apiFields: [],
    };
  },

  created() {
    this.loadFormData();
  },
  computed: {
    getPaymentConfig() {
      return getFieldConfig({
        apiFields: this.apiFields,
        fieldType: this.fieldType,
        country: 'US',
      });
    },
  },

  methods: {
    // 加载表单数据
    async loadFormData() {
      this.loading = true;
      try {
        // 获取API数据
        this.apiFields = await fetchFormFields(this.fieldType);

        // 使用getFieldConfig处理API字段
        this.formFields = getFieldConfig({
          apiFields: this.apiFields,
          fieldType: this.fieldType,
          country: 'US',
        });
      } catch (error) {
        console.error('加载表单失败:', error);
      } finally {
        this.loading = false;
      }
    },

    // 处理表单提交
    async handleSubmit(formData) {
      // // 切换到完整验证模式（包含必填校验）
      if (this.$refs.dynamicFormRef) {
        this.$refs.dynamicFormRef.setValidationMode('full');
      }

      this.$refs.dynamicFormRef.handleSubmit();
      // this.result = {
      //   message: formData,
      // };
    },

    validateAndSubmit() {
      // 将两个表单都设置为完整验证模式
      if (this.$refs.dynamicFormRefPayment) {
        this.$refs.dynamicFormRefPayment.setValidationMode('full');
      }

      if (this.showBillingForm && this.$refs.dynamicFormRefBilling) {
        this.$refs.dynamicFormRefBilling.setValidationMode('full');
      }

      // 延迟执行验证，确保验证模式已更新
      this.$nextTick(() => {
        // 验证支付表单
        const paymentValid = this.$refs.dynamicFormRefPayment ? this.$refs.dynamicFormRefPayment.validate() : false;

        // 验证账单表单（如果显示）
        const billingValid = !this.showBillingForm || (this.$refs.dynamicFormRefBilling ? this.$refs.dynamicFormRefBilling.validate() : false);

        // 只有当两个表单都验证通过时才提交
        if (paymentValid && billingValid) {
          // 获取表单数据
          const paymentData = this.$refs.dynamicFormRefPayment.getFormData();
          const billingData = this.showBillingForm && this.$refs.dynamicFormRefBilling
            ? this.$refs.dynamicFormRefBilling.getFormData()
            : {};

          // 合并数据并提交
          this.$emit('submit', { ...paymentData, ...billingData });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.checkout-container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;

  h1 {
    margin-bottom: 20px;
    text-align: center;
  }

  .form-wrapper {
    background: #f8f8f8;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
    min-height: 150px;
  }

  .no-fields {
    text-align: center;
    color: #999;
    padding: 30px 0;
  }

  .result-box {
    background: #e6f7ff;
    padding: 15px;
    border-radius: 4px;

    pre {
      white-space: pre-wrap;
      word-break: break-all;
    }
  }
}
</style>
